import React, { useMemo } from 'react';

import { isRetailVenue } from 'common/utils';
import { useCanViewPickingRoute, MessagePage } from 'modules/experience-core';
import { useExperienceModuleContext } from 'modules/experience-core';
import { MenuLocaleContext } from 'modules/menu/MenuLocaleContext';
import { MenuModuleContextProvider, useMenuModuleContext } from 'modules/menu/context';
import useMenuData from 'modules/menu/useMenuData';

import PickingRoutePage from './components/PickingRoutePage';

export const PickingRoute = () => {
  const { venue } = useMenuModuleContext();

  const { menu } = useMenuData();

  const menuLocaleContext = useMemo(
    () => ({
      country: venue.country,
      primaryLanguage: menu?.primary_language || ('en' as const),
      timezone: venue.timezone,
    }),
    [menu, venue.country, venue.timezone],
  );

  return (
    <MenuLocaleContext.Provider value={menuLocaleContext}>
      <PickingRoutePage venueId={venue.id} menuId={venue.menu} isExperienceFlow />
    </MenuLocaleContext.Provider>
  );
};

export const ExperiencePickingRoute = () => {
  const { selectedExperienceVenueEntity } = useExperienceModuleContext();
  const canViewPickingRoutes = useCanViewPickingRoute(
    selectedExperienceVenueEntity ? [selectedExperienceVenueEntity] : [],
  );

  if (!selectedExperienceVenueEntity) {
    return <MessagePage variant="error" />;
  }

  const venue = selectedExperienceVenueEntity.experienceEntityObject;
  const isSupported = venue.type !== 'daas' && isRetailVenue(venue);

  if (!isSupported) {
    return <MessagePage variant="not_supported" />;
  }

  return canViewPickingRoutes ? (
    <MenuModuleContextProvider value={{ venue }}>
      <PickingRoute />
    </MenuModuleContextProvider>
  ) : (
    <MessagePage variant="missing_permissions" />
  );
};
